import { InputNumber } from 'antd';
import styled from 'styled-components';

export const StyledInputNumber = styled(InputNumber)`
    width: 100%;
`;

export const AddonWrapper = styled.div`
    display: flex;
    align-items: center;
    border-radius: 4px;
`;
